<template>
    <div>

        <main role="main">

            <div class="container">

                <loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="true"></loading>

                <div class="row">

                    <div class="col-md-12 text-muted" v-if="logoutMode">
                        <h2 class="mt-3"><i class="fas fa-circle-notch fa-spin"></i> {{$t('text.dashboard.logoutInProgress')}}</h2>
                    </div>

                    <div class="col-md-8 offset-md-2" v-if="!logoutMode">

                        <h1 class="my-5">
                            {{$t('text.dashboard.welcomeMessage1')}} <br/>
                            <small>{{$t('text.dashboard.welcomeMessage2')}} <br/>
                            </small></h1>

                        <h2><small>
                            {{$t('text.dashboard.loggedInAs')}} <b>{{getUserName}}</b>


                                <span v-if="displayPermissions.length > 0">
                                                (<span class="" v-for="(item, index) in displayPermissions"
                                                       :key="'item_' + index">{{item.trim()}}<span
                                        v-if="index < displayPermissions.length-1">, </span></span>)</span>. <br/><br/>

                            {{$t('text.dashboard.contactEmailForHelp')}}: <a :href="'mailto:' + getHelpEmailAddress">{{getHelpEmailAddress}}</a>.</small>
                        </h2>

                    </div>
                </div>

<!--              <b-row>-->
<!--                <b-col md="12" class="mt-5">-->
<!--                  <loading :active.sync="isCalendarWidgetLoading"-->
<!--                           :can-cancel="false"-->
<!--                           :is-full-page="false"></loading>-->
<!--                  <h2 class="mt-5">eKoledar</h2>-->
<!--                  <iframe class="mt-2 w-100" src="https://vm-ekoledar-test.rettro.si/eKoledar/widget-calendar" style="border: 0px; min-height: 1100px;" @load="() => { isCalendarWidgetLoading = false; }"></iframe>-->
<!--                </b-col>-->
<!--              </b-row>-->
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';

    library.add(faHome);

    export default {
        name: 'Dashboard',
        components: {
            Loading,
            SidebarNavigation
        },

        data() {
            return {
                sites: [],
                user: {},
                error: '',
                isLoading: this.$route.query && this.$route.query.logout ? true : false,
                logoutMode: this.$route.query && this.$route.query.logout ? true : false,
              istLoading: false,
              isCalendarWidgetLoading: true
            };
        },

        beforeCreate: function () {
            const _this = this;
            document.body.className = 'dashboard';

            console.log("params", _this.$route.query);
            if (_this.$route.query && _this.$route.query.logout) {
                _this.isLoading = true;
                _this.logoutMode = true;
                this.$router.push(this.$route.path).catch(()=>{});
                setTimeout(function () {
                    _this.$keycloak.logoutFn();
                },100);


            }
        },
        computed: {
            getUserName() {
                console.log("this.$store.getters.getUserName", this.$store.getters.getUserName);
                return this.$store.getters.getUserName;
            },
            getPermissions() {
                return this.$store.getters.getPermissions;
            },

            displayPermissions() {
                let permissions = [];
                if (this.getPermissions.length === 0) {
                    return [];
                }
                _.map(this.getPermissions, function (val) {
                    if (permissions.indexOf(val.description) === -1) {
                        permissions.push(val.description);
                    }
                });

                console.log("permissions ->", permissions);

                return permissions;
            },

            getHelpEmailAddress() {
                return config.links.helpEmail
            }
        },

        methods: {}


    };
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue